var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58373 0.394937L11.8927 10.6965C12.0969 11.0927 12.001 11.6173 11.6786 11.8682C11.568 11.9543 11.4398 12 11.3089 12H0.691002C0.309372 12 0 11.6198 0 11.1508C0 10.9899 0.0371867 10.8324 0.10723 10.6965L5.41618 0.394937C5.62038 -0.00127767 6.04727 -0.119049 6.36968 0.131887C6.45597 0.19905 6.52908 0.288889 6.58373 0.394937Z",
    fill: "#EE8B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.65088V7.27588",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10.0359,
    r: 0.9375,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.b5457ddde598bc3fbfdb4d4a0dd3b51c.svg";
export { ForwardRef as ReactComponent };